import styles from './CliPrivateIcon.module.css'

interface CliPrivateIconProps {
  showConnectedDot?: boolean
}

function CliPrivateTerminalSvg() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        d="M12 6C13.6569 6 15 7.34315 15 9V10.168C15.5912 10.4488 16 11.0519 16 11.75V14.25C16 15.2165 15.2165 16 14.25 16H9.75C8.7835 16 8 15.2165 8 14.25V11.75C8 11.0519 8.40876 10.4488 9 10.168V9C9 7.34315 10.3431 6 12 6ZM14.252 0.998047C15.2185 0.998311 16.0029 1.7824 16.0029 2.74902V4.82227H16V5.57422C16 5.98843 15.6642 6.32422 15.25 6.32422C14.836 6.32402 14.5 5.98831 14.5 5.57422V3.21973C14.5 3.20661 14.5013 3.19361 14.502 3.18066V2.74902C14.502 2.61108 14.3899 2.49831 14.252 2.49805H1.74902C1.61091 2.49805 1.49805 2.61091 1.49805 2.74902V13.252C1.49818 13.39 1.611 13.502 1.74902 13.502H3.7002C3.71915 13.5005 3.73849 13.499 3.75781 13.499H6.1123C6.52641 13.4992 6.8623 13.8349 6.8623 14.249C6.8623 14.6632 6.52641 14.9989 6.1123 14.999H5.92773V15.002H1.74902C0.78232 15.002 -0.00181662 14.2186 -0.00195312 13.252V2.74902C-0.00195312 1.78224 0.782237 0.998047 1.74902 0.998047H14.252ZM3.71875 5.21875C4.01176 4.92612 4.4874 4.92589 4.78027 5.21875L7.03027 7.46973C7.17079 7.61037 7.24997 7.80119 7.25 8C7.25 8.19883 7.17077 8.38961 7.03027 8.53027L4.78027 10.7812C4.48738 11.0742 4.01175 11.074 3.71875 10.7812C3.4259 10.4883 3.42603 10.0137 3.71875 9.7207L5.43945 8L3.71875 6.28027C3.42576 5.9873 3.42577 5.51173 3.71875 5.21875ZM12 7.5C11.1716 7.5 10.5 8.17157 10.5 9V10H13.5V9C13.5 8.17157 12.8284 7.5 12 7.5Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function CliPrivateIcon({showConnectedDot = false}: CliPrivateIconProps) {
  const ariaLabel = showConnectedDot ? 'Private session connected' : 'Private remote session'

  return (
    <span className={styles.wrapper} role="img" aria-label={ariaLabel}>
      <CliPrivateTerminalSvg />
      {showConnectedDot && <span data-testid="connected-dot" className={styles.connectedDot} aria-hidden="true" />}
    </span>
  )
}
